// Function to check the current path and log a message if it's the cart page
function checkCartPage() {
    // Get the current path from the window location
    const currentPath = window.location.pathname;

    // Define the path for the cart page
    const cartPath = '/cart'; // Adjust this path if your cart page URL is different

    // Check if the current path matches the cart page path
    if (currentPath === cartPath) {
     
        
        // Create a style element
        const style = document.createElement('style');
        style.type = 'text/css';

        // Define your CSS rules for the cart page
        const css = `
            /* Example styles for the cart page */
     .quantity {
    width: calc(58px / var(--font-body-scale) + var(--inputs-border-width)* 1) !important;
    height: 61px !important;
    border: 1px solid #000;
}
.quantity__input {
    width: 27px !important;
    border: 1px solid #000;
    position: absolute;
    height: 60px !important;
    top: 0;
    padding: -1px;
    color: var(--Brown, #7b4a00);
    text-align: center;
    font-family: Josefin Sans;
    font-size: 18px !important;
    font-style: normal;
    font-weight: 700 !important;
    line-height: normal;
}


        `;

        // Append the CSS rules to the style element
        style.appendChild(document.createTextNode(css));

        // Append the style element to the document head
        document.head.appendChild(style);
    }
}

// Call the function on page load
document.addEventListener('DOMContentLoaded', checkCartPage);



document.addEventListener('DOMContentLoaded', (event) => {
    const currentPath = window.location.pathname;
    const headerWrapper = document.querySelector('.header-wrapper');
    const searchInput = document.querySelector('.search__input.field__input');
    const resetButton = document.querySelector('.field__button_1');
    const searchLabel = document.querySelector('label[for="Search-In-Modal"]');
    const searchButton = document.querySelector('.search__button.field__button');

    if (currentPath === '/search') {
      headerWrapper.style.background = '#321e00 !important';


        if (searchInput) {
            // Initially set the color to #bfbfbf to make the elements less visible
            if (resetButton) {
                resetButton.style.color = '#bfbfbf';
                const svg = resetButton.querySelector('svg');
                if (svg) {
                    svg.style.color = '#bfbfbf';
                }
            }

            // Initially set the color of the search label
            searchLabel.style.color = '#bfbfbf';

            // Once DOM is loaded, hide the elements completely
            setTimeout(() => {
                if (resetButton) {
                    resetButton.style.display = 'none';
                    const svg = resetButton.querySelector('svg');
                    if (svg) {
                        svg.style.display = 'none';
                    }
                }
                searchLabel.style.display = 'none';
            }, 0);
        } else {
            // Optionally reset the display or set other styles if the input is not found
            if (resetButton) {
                resetButton.style.color = ''; // Reset to default
                const svg = resetButton.querySelector('svg');
                if (svg) {
                    svg.style.color = ''; // Reset to default
                }
            }
        }
    } else {
        // Optionally reset the background or set other styles for other paths
        headerWrapper.style.background = ''; // Resetting to default
    }

    // Add focus and blur event listeners for search input
    if (searchInput && searchLabel) {
        const hideLabel = () => {
            searchLabel.style.display = 'none';
        };

        searchInput.addEventListener('focus', hideLabel);

        searchInput.addEventListener('blur', () => {
            if (!searchInput.value) { // Show label only if input is empty
                searchLabel.style.display = 'block';
            }
        });

        // Ensure label stays hidden when the user enters text and clicks the search button
        searchButton.addEventListener('click', hideLabel);

        // Also handle form submission to hide the label
        searchInput.form.addEventListener('submit', hideLabel);
    }
});



document.addEventListener('DOMContentLoaded', (event) => {
    const currentPath = window.location.pathname;
    const headerWrapper = document.querySelector('.header-wrapper');
    const searchInput = document.querySelector('#Search-In-Template');
    const resetButton = document.querySelector('.reset__button.field__button');
    const searchLabel = document.querySelector('label[for="Search-In-Template"]');
    const searchButton = document.querySelector('.search__button.field__button');

    const isMobile = window.matchMedia('(max-width: 640px)').matches;

    if (currentPath === '/search') {
        headerWrapper.style.background = '#321e00';

        if (searchInput) {
            // Initially hide the label and reset button
            if (resetButton) {
                resetButton.style.display = 'none';
                const svg = resetButton.querySelector('svg');
                if (svg) {
                    svg.style.display = 'none';
                }
            }

            if (!isMobile) {
                searchLabel.style.display = 'none';
            }

            // Show the reset button when the input has a value
            searchInput.addEventListener('input', () => {
                if (searchInput.value) {
                    if (resetButton) {
                        resetButton.style.display = 'block';
                        const svg = resetButton.querySelector('svg');
                        if (svg) {
                            svg.style.display = 'block';
                        }
                    }
                } else {
                    if (resetButton) {
                        resetButton.style.display = 'none';
                        const svg = resetButton.querySelector('svg');
                        if (svg) {
                            svg.style.display = 'none';
                        }
                    }
                }

                if (isMobile && !searchInput.value) {
                    searchLabel.style.display = 'block';
                } else if (isMobile) {
                    searchLabel.style.display = 'none';
                }
            });
        } else {
            // Optionally reset the display or set other styles if the input is not found
            if (resetButton) {
                resetButton.style.display = ''; // Reset to default
                const svg = resetButton.querySelector('svg');
                if (svg) {
                    svg.style.display = ''; // Reset to default
                }
            }
        }
    } else {
        // Optionally reset the background or set other styles for other paths
        headerWrapper.style.background = ''; // Resetting to default
    }

    // Add focus and blur event listeners for search input
    if (searchInput && searchLabel) {
        const hideLabel = () => {
            searchLabel.style.display = 'none';
        };

        searchInput.addEventListener('focus', hideLabel);

        searchInput.addEventListener('blur', () => {
            if (!searchInput.value && !isMobile) { // Show label only if input is empty and not mobile
                searchLabel.style.display = 'block';
            }
        });

        // Ensure label stays hidden when the user enters text and clicks the search button
        searchButton.addEventListener('click', hideLabel);

        // Also handle form submission to hide the label
        searchInput.form.addEventListener('submit', hideLabel);
    }
});


document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/account/login') {
      var headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) {
        headerWrapper.style.background = '#321e00';
      }
    } else {
    }
  });



// document.addEventListener('DOMContentLoaded', function() {
//     // Check if the current page is the About Us page
//     if (window.location.pathname === '/pages/about-us') {

//         let lastScrollTop = 0;
//         const header = document.querySelector('.header-wrapper');

//         window.addEventListener('scroll', function() {
//             let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//             if (scrollTop > lastScrollTop) {
//                 // Scrolling down
//                 header.classList.add('hidden'); // Add hidden class to hide header
//                 header.classList.remove('scrolling-up'); // Remove scrolling-up class
//             } else {
//                 // Scrolling up
//                 header.classList.remove('hidden'); // Show header
//                 if (scrollTop > 0) {
//                     header.classList.add('scrolling-up'); // Add scrolling-up class
//                 } else {
//                     header.classList.remove('scrolling-up'); // Remove scrolling-up class if at the top
//                 }
//             }
//             lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
//         });
//     } else {
      
//     }
// });

// Check if the current page path matches '/pages/about-us'
if (window.location.pathname === '/pages/about-us') {
    console.log('Scroll behavior with header, inline menu, and list menu adjustments.');

    // Create a new style element
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
        .header__inline-menu {
            display: block;
            position: absolute;
            right: 45px;
            top: 108px;
        }

        .header-wrapper {
            background: transparent;
            transition: background 0.3s ease-in-out;
        }

        .list-menu {
            padding-top: 0px; /* Default padding */
            transition: padding-top 0.3s ease-in-out; /* Smooth transition */
        }

        .list-menu--inline {
            gap: 48px; /* Default gap */
            transition: gap 0.3s ease-in-out; /* Smooth transition */
        }

        /* Scroll-specific styles */
        .header-wrapper.scrolled {
            background: #321e00 !important; /* Background color when scrolling down */
        }

        .header__inline-menu.scrolled {
            right: 26%;
            top: 1px;
        }

        .list-menu.scrolled {
            padding-top: 27px; /* Apply padding-top when scrolling down */
        }

        .list-menu--inline.scrolled {
            gap: 100px; /* Apply gap when scrolling down */
        }

        /* Hide elements */
        .header__icons.hidden,
        .header__heading-logo-wrapper.hidden {
            display: none;
        }
    `;
    // Append the style element to the head
    document.head.appendChild(style);

    // Your scroll behavior JavaScript here
    let lastScrollTop = 0;
    const headerWrapper = document.querySelector('.header-wrapper');
    const header = document.querySelector('.header'); // Target the .header element
    const headerInlineMenu = document.querySelector('.header__inline-menu');
    const headerIcons = document.querySelector('.header__icons');
    const headerHeading = document.querySelector('.header__heading-logo-wrapper');
    const listMenu = document.querySelector('.list-menu');
    const listMenuInline = document.querySelector('.list-menu--inline');

    window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            // Scrolling down, apply scrolled styles and hide elements
            headerWrapper.classList.add('scrolled');
            headerInlineMenu.classList.add('scrolled');
            headerIcons.classList.add('hidden');
            headerHeading.classList.add('hidden');
            listMenu.classList.add('scrolled');
            listMenuInline.classList.add('scrolled');
            header.style.paddingTop = '32px'; // Set padding when scrolling down
            header.style.paddingBottom = '14px';
        } else {
            // Scrolling up
            if (scrollTop === 0) {
                // At the very top, revert to transparent background and adjust padding
                headerWrapper.classList.remove('scrolled');
                headerWrapper.style.background = 'transparent';
                header.style.paddingTop = '34px'; // Set padding at the top
                header.style.paddingBottom = '28px';
            } else {
                // Still scrolling up but not at the top, maintain the background color
                headerWrapper.style.background = '#321e00';
                header.style.paddingTop = '12px'; // Set padding when scrolling up
                header.style.paddingBottom = '12px';
            }

            // Revert to default styles and show elements
            headerInlineMenu.classList.remove('scrolled');
            headerIcons.classList.remove('hidden');
            headerHeading.classList.remove('hidden');
            listMenu.classList.remove('scrolled');
            listMenuInline.classList.remove('scrolled');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    });
}


